import { render, staticRenderFns } from "./birthdayWishes.vue?vue&type=template&id=7366cec0&scoped=true&"
import script from "./birthdayWishes.vue?vue&type=script&lang=js&"
export * from "./birthdayWishes.vue?vue&type=script&lang=js&"
import style0 from "./birthdayWishes.vue?vue&type=style&index=0&id=7366cec0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7366cec0",
  null
  
)

export default component.exports